import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-kitchen-layout',
  templateUrl: './layout.component.html',
})
export class KitchenLayoutComponent implements OnInit {
  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    public gtm: GTM,
    public modalService: ModalService,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) {}

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/disposition`, 'Cuisine | Choix', {
      stepNumber: 3,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });
  }

  selectLayout(layoutId: string) {
    if (layoutId === 'U') {
      this.modalService.display(MODAL.MESSAGE, {
        titleRef: 'popins.layout_u.title',
        contentRef: 'popins.layout_u.text',
        buttons: [
          {
            labelRef: 'popins.layout_u.confirm',
            primary: true,
            action: () => {
              this.modalService.close();
              this.current.kitchen.layoutRef = 'U';
              this.onComplete.emit();
            },
          },
        ],
      });
    } else {
      this.current.kitchen.layoutRef = layoutId;
      this.onComplete.emit();
    }
  }
}
